'use client';

const AnnouncementsContainer = () => {
  return null;
};

export default AnnouncementsContainer;
